
export const getFromCache = <T extends {}>(storageName: any): T | void => {
    const value = localStorage.getItem(storageName);
    
    if(value) {
        return JSON.parse(value)
    }
    return undefined
}
